import axios from 'axios';

import config from '@/config';

export const postCheckUser = async mail => {
  return await axios.post(`${config.API_REDE_IZEE_URL}/auth/check-user`, { username: mail });
};
